import React, { useState } from 'react';
import Login from './Login';
import RegistrationForm from './RegistrationForm';

const Auth = () => {
  const [isLogin, setIsLogin] = useState(true);

  const toggleMode = () => {
    setIsLogin(!isLogin);
  };

  return (
    <div>
      {isLogin ? (
        <Login onToggleMode={toggleMode} />
      ) : (
        <RegistrationForm onToggleMode={toggleMode} />
      )}
    </div>
  );
};

export default Auth;
